import { Action } from '@ngrx/store';
import { DatesIntervalRequest, DatesInterval } from '../../global/interfaces';
import {
  ValuationsPortfolioRequest,
  ValuationsPortfolio,
  ValuationsPricesRequest,
  ValuationsPrices,
  ValuationsType, PriceType, ValuationsCsvRequestPayload
} from './valuations.models';

export enum ActionTypes {
  LOAD_VALUATIONS_DATES                = '[Valuations] Load Valuations Dates Action',
  LOAD_VALUATIONS_DATES_SUCCESS        = '[Valuations] Load Valuations Dates Success Action',
  LOAD_VALUATIONS_DATES_FAILED         = '[Valuations] Load Valuations Dates Failed Action',

  LOAD_VALUATIONS_PORTFOLIO            = '[Valuations] Load Valuations Portfolio Action',
  LOAD_VALUATIONS_PORTFOLIO_SUCCESS    = '[Valuations] Load Valuations Portfolio Success Action',
  LOAD_VALUATIONS_PORTFOLIO_FAILED     = '[Valuations] Load Valuations Portfolio Failed Action',

  LOAD_VALUATIONS_PRICES               = '[Valuations] Load Valuations Prices Action',
  LOAD_VALUATIONS_PRICES_SUCCESS       = '[Valuations] Load Valuations Prices Success Action',
  LOAD_VALUATIONS_PRICES_FAILED        = '[Valuations] Load Valuations Prices Failed Action',

  LOAD_VALUATIONS_TOTAL_PRICES         = '[Valuations] Load Valuations Total Prices Action',
  LOAD_VALUATIONS_TOTAL_PRICES_SUCCESS = '[Valuations] Load Valuations Total Prices Success Action',
  LOAD_VALUATIONS_TOTAL_PRICES_FAILED  = '[Valuations] Load Valuations Total Prices Failed Action',

  EXPORT_VALUATIONS_CSV                = '[Valuations] Export Valuations Csv Action',

  SET_VALUATIONS_TYPE_FILTER           = '[Valuations] Set Valuations Type Filter Action',
  SET_VALUATIONS_PRICE_FILTER          = '[Valuations] Set Valuations Price Filter Action',
  SET_VALUATIONS_FUNDS_FILTER          = '[Valuations] Set Valuations Funds Filter Action',
  SET_VALUATIONS_FUND_FILTER           = '[Valuations] Set Valuations Fund Filter Action',
  SET_VALUATIONS_FROM_FILTER           = '[Valuations] Set Valuations From Filter Action',
  SET_VALUATIONS_TO_FILTER             = '[Valuations] Set Valuations To Filter Action',

  RESET_VALUATIONS_DATA                = '[Valuations] Reset Valuations Data Action',
  RESET_VALUATIONS_FILTER              = '[Valuations] Reset Valuations Filter Action',
}

export class LoadValuationsDatesAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_DATES;

  public constructor(public payload: DatesIntervalRequest) {
  }
}

export class LoadValuationsDatesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_DATES_SUCCESS;

  public constructor(public payload: DatesInterval) {
  }
}

export class LoadValuationsDatesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_DATES_FAILED;

  public constructor(public payload: any) {
  }
}

export class LoadValuationsPortfolioAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_PORTFOLIO;

  public constructor(public payload: ValuationsPortfolioRequest) {
  }
}

export class LoadValuationsPortfolioSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_PORTFOLIO_SUCCESS;

  public constructor(public payload: ValuationsPortfolio) {
  }
}

export class LoadValuationsPortfolioFailedAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_PORTFOLIO_FAILED;

  public constructor(public payload: any) {
  }
}

export class LoadValuationsPricesAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_PRICES;

  public constructor(public payload: ValuationsPricesRequest) {
  }
}

export class LoadValuationsPricesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_PRICES_SUCCESS;

  public constructor(public payload: ValuationsPrices[]) {
  }
}

export class LoadValuationsPricesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_PRICES_FAILED;

  public constructor(public payload: any) {
  }
}

export class LoadValuationsTotalPricesAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_TOTAL_PRICES;

  public constructor(public payload: ValuationsPricesRequest) {
  }
}

export class ValuationsCsvExportAction implements Action {
  readonly type = ActionTypes.EXPORT_VALUATIONS_CSV;

  public constructor(public payload: ValuationsCsvRequestPayload) {
  }
}

export class LoadValuationsTotalPricesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_TOTAL_PRICES_SUCCESS;

  public constructor(public payload: ValuationsPrices[]) {
  }
}

export class LoadValuationsTotalPricesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_VALUATIONS_TOTAL_PRICES_FAILED;

  public constructor(public payload: any) {
  }
}

export class SetValuationsTypeFilterAction implements Action {
  readonly type = ActionTypes.SET_VALUATIONS_TYPE_FILTER;

  public constructor(public payload: ValuationsType | PriceType) {
  }
}

export class SetValuationsPriceFilterAction implements Action {
  readonly type = ActionTypes.SET_VALUATIONS_PRICE_FILTER;

  public constructor(public payload: PriceType) {
  }
}

export class SetValuationsFundsFilterAction implements Action {
  readonly type = ActionTypes.SET_VALUATIONS_FUNDS_FILTER;

  public constructor(public payload: string[]) {
  }
}

export class SetValuationsFundFilterAction implements Action {
  readonly type = ActionTypes.SET_VALUATIONS_FUND_FILTER;

  public constructor(public payload: string[]) {
  }
}

export class SetValuationsFromFilterAction implements Action {
  readonly type = ActionTypes.SET_VALUATIONS_FROM_FILTER;

  public constructor(public payload: string) {
  }
}

export class SetValuationsToFilterAction implements Action {
  readonly type = ActionTypes.SET_VALUATIONS_TO_FILTER;

  public constructor(public payload: string) {
  }
}

export class ResetValuationsFilterAction implements Action {
  readonly type = ActionTypes.RESET_VALUATIONS_FILTER;
}
export class ResetValuationsDataAction implements Action {
  readonly type = ActionTypes.RESET_VALUATIONS_DATA;
}

export type Actions =
  LoadValuationsDatesAction |
  LoadValuationsDatesSuccessAction |
  LoadValuationsDatesFailedAction |
  LoadValuationsPortfolioAction |
  LoadValuationsPortfolioSuccessAction |
  LoadValuationsPortfolioFailedAction |
  LoadValuationsPricesAction |
  LoadValuationsPricesSuccessAction |
  LoadValuationsPricesFailedAction |
  LoadValuationsTotalPricesAction |
  LoadValuationsTotalPricesSuccessAction |
  LoadValuationsTotalPricesFailedAction |
  ValuationsCsvExportAction |
  SetValuationsTypeFilterAction |
  SetValuationsPriceFilterAction |
  SetValuationsFundsFilterAction |
  SetValuationsFundFilterAction |
  SetValuationsFromFilterAction |
  SetValuationsToFilterAction |
  ResetValuationsFilterAction |
  ResetValuationsDataAction;
